import React, { Component } from "react";
import {
  Form,
  Row,
  Col,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Alert,
  Progress,
  FormText
} from "reactstrap";

import FileUpload from 'react-dropzone';
import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";

import SelectListComponent from "../utils/selectList";
import PaymentFileTemplate from "./PaymentFileTemplate.xlsx";

import FileIcon from 'react-icons/lib/md/cloud-upload';
import NotificationIcon from 'react-icons/lib/md/notifications';

import { appHelpers, authHeader } from "../../_helpers";

import './style.css';

const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 }
];

const fileUploadStyle = {
  width  : "100%",
  height : "100%",
  paddingTop: "20px",
  paddingBottom: "20px",
  border : "1px dashed #aaa",
  borderRadius : "10px"
};

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class PaymentUploadViewContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthOptions: months,
      selectedMonth: '',
      file : null,
      fileName : null,

      //page error
      contentError: false, //Errors that affect content on the page
      componentErrorMessages: [], //Errors generated within the component form
      componentError: false, //Errors generated within the component
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

     // alert messages
      alertMessage: {
        type: null,
        message: null
      }
    };

  }



  displayAlert = (message, type) => {
    let alertMessage = this.state.alertMessage;
    alertMessage["message"] = message;
    alertMessage["type"] = type;
  }


  onChange = (event) => {
    this.setState({file : event.target.files[0]})
  }

  onDrop = (files) => {

    this.setState({file : files[0]})
    this.setState({fileName : files[0].name})
  }

  handleFormSubmit = (event) => {

    event.preventDefault();
    const { dispatch } = this.props;
    this.setState({ contentError: false });

    this.setState({ alertMessage: {} });

    dispatch(apiActions.startRequest());

    let data = new FormData();
    data.append('file', this.state.file);
    data.append('Month', this.state.selectedMonth.value);

    let url_ = appConstants.PAS_URL + '/api/payment/processfileasmultipartcontent';

    appHelpers.postFormDataRequest(url_, data, authHeader()).then(
      (response) => {
        let msg = "";
        if (response.data === "") {
          msg = "Payment file uploaded successfully";
          this.displayAlert(msg, appConstants.NOTIFY_SUCCESS)
        } else {
          msg = "The file has been successfully processed but the following document types have been found and ignored: <br>" +
          response.data;
          this.displayAlert(msg, appConstants.NOTIFY_WARNING)

        }
        dispatch(apiActions.endRequest());
        this.setState({selectedMonth : "", file: null, fileName: null});
      }
    ).catch(
      (error) => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.displayAlert(errorMessage, appConstants.NOTIFY_DANGER);
        dispatch(apiActions.endRequest());
        this.setState({contentError: errorMessage});

        this.setState({selectedMonth : "", file: null, fileName: null});
        // this.setState({file : null})
        // this.setState({fileName : null})

      }
    )

  };

  render() {
    const { monthOptions, file, fileName, alertMessage, selectedMonth  } = this.state;
    const { requesting, pageRequesting } = this.props;

    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4" style={{overflow: "visible"}}>
           {/*Progress bar for Pending API Request*/}
           { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }

            {
              <CardBody>

                <div className="clearfix">&nbsp;</div>

                <div>

                  <Form onSubmit={this.handleFormSubmit}>
                  <Row>
                    {alertMessage.message &&
                      <Col sm="12" md={{size: 6, offset: 3}} className="text-center">
                        <Alert color={alertMessage.type}>
                        <NotificationIcon size="20"/>
                        <span dangerouslySetInnerHTML={{__html : alertMessage.message}}></span>
                        </Alert>
                      </Col>
                    }

                    </Row>
                    <Row>
                      <Col sm="12" md={{size: 6, offset: 3}}>
                        <FormGroup className="mb-4">
                          <Label>Month</Label>

                          <SelectListComponent
                            placeholder={"Select month..."}
                            data={monthOptions}c
                            valueKey="value"
                            textField="label"
                            selectValue={selectedMonth}
                            onValueChange={(payload) => this.setState({selectedMonth : payload})}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                    <Col sm="12" md={{size: 6, offset: 3}}>
                      <FormGroup className="mb-4">

                    <FileUpload onDrop={this.onDrop} style={fileUploadStyle}>

                      <div className="text-center">
                      <FileIcon size="60" color="#43a8df"/>

                      {!fileName && <div>
                        <h5>Drag & drop payment file here</h5>
                        <p>or click to upload</p>
                        <FormText className='muted'>
                            Only .xlsx files are accepted for upload.
                        </FormText>
                        </div>
                      }
                      {fileName &&
                        <div>
                         <p>{fileName}</p>
                        </div>
                      }
                      </div>
                    </FileUpload>
                    <FormText color="mt-3">
                        <a href={PaymentFileTemplate}>Download Template</a>
                    </FormText>
                    </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm="12" md={{size: 6, offset: 3}}>
                        <label>&nbsp;</label>
                        <Button disabled={!selectedMonth || !file} className="btn-avi-primary">Upload</Button>
                      </Col>
                    </Row>

                  </Form>

                </div>

                {/* <hr /> */}
              </CardBody>
            }
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { pageRequesting, requesting } = state.api;
  const { modal, alert } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert
  };
}
export default connect(mapStateToProps)(PaymentUploadViewContent);



// WEBPACK FOOTER //
// ./src/views/payment-upload/view-content.js